import SecretsField from '@apps/platform/admin/components/secretsfield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    provider: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { provider } = this.props
    return {
      title: 't(Edit Provider)',
      method: 'PATCH',
      endpoint: `/api/admin/platform/providers/${provider.id}/edit`,
      action: `/api/admin/platform/providers/${provider.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true },
            { label: 't(Logo)', name: 'logo_id', type: 'attachmentfield',  multiple: false },
            { label: 't(Admin Domain)', name: 'admin_domain', type: 'textfield', required: true },
            { label: 't(Short Domain)', name: 'short_domain', type: 'textfield', required: true },
            { label: 't(Support Email)', name: 'support_email', type: 'emailfield', required: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
